import { render, staticRenderFns } from "./OurHomestays.vue?vue&type=template&id=6cedc4d4"
import script from "./OurHomestays.vue?vue&type=script&lang=js"
export * from "./OurHomestays.vue?vue&type=script&lang=js"
import style0 from "./OurHomestays.vue?vue&type=style&index=0&id=6cedc4d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports